module.exports = __webpack_public_path__ + "static/media/personaje.b5007e2d.png";